import { forwardRef } from 'react';
import clsx from 'clsx';
import { TestimonialsV5 } from 'types/studio/studio';
import { getThemeCSSClass } from 'shared/utils/getThemeCSSClass';
import styles from './TestimonialsSliderThumb.module.scss';
import { StudioBaseImageV2 } from '../../StudioBaseImage/StudioBaseImage';

type Props = {
  image: NonNullable<TestimonialsV5['cards']>[number]['image'];
  onClick: () => void;
  index: number;
  selectedSlide: number;
  visibleOnPageLoad: boolean;
} & Pick<TestimonialsV5, 'theme'>;

const TestimonialsSliderThumb = forwardRef<HTMLDivElement, Props>(
  ({ image, onClick, index, selectedSlide, theme, visibleOnPageLoad }: Props, ref) => (
    <div ref={ref} className={styles.thumbWrap}>
      <div className={styles.thumb}>
        <button type="button" onClick={onClick} className={styles.button}>
          {image && (
            <StudioBaseImageV2
              image={image}
              className={styles.image}
              eagerLoading={visibleOnPageLoad}
            />
          )}
        </button>
      </div>
      {index === 0 && (
        <div
          className={clsx(styles.indicator, getThemeCSSClass(theme))}
          style={{ transform: `translateX(${selectedSlide * 100}%)` }}
        />
      )}
    </div>
  )
);

TestimonialsSliderThumb.displayName = 'TestimonialsSliderThumb';

export default TestimonialsSliderThumb;
